module.exports = __webpack_public_path__ + "img/logo.508dc83f.png";